import React, { useEffect, useState, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledTablePmePrograma } from "../../../styled-components/StyledTablePmePrograma.style";
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { MobileContext } from "../../../contexts/MobileContext";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";

import { ModalPerfilPme } from "../../../components/ModalPerfilPme";

import api from '../../../services/api';
import Flex from '@react-css/flex';
import { useHistory } from "react-router-dom";

export const PmePerfil = () => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);

    const [listaPerfisData, setListaPerfisData] = useState(null);
    const [perfisList, setPerfisList] = useState([]);
    const [modalPerfilPme, setModalPerfilPme] = useState(false);
    const [selectedPerfil, setSelectedPerfil] = useState(null);

    const getPerfis = async() => {
        const response = await api.get('PmePerfil', config);
        setListaPerfisData(response);
    };

    const handleUpdatePerfis = (updatedList) => {
        setPerfisList(updatedList.map(perfil => ({
            id: perfil.idPerfil,
            label: perfil.nome,
            value: perfil.idPerfil
        })));
    };

    const afterModalPerfilPmeOpen = () => { };
    const openModalPerfilPmeOpen = () => {
        setModalPerfilPme(true);
    };
    const closeModalPerfilPme = () => {
        setModalPerfilPme(false);
    }

    const getacoes = (perfil) => {
        return (
            <Flex >
                <span
                    className="cursor-pointer color-icon-default m-1"
                    onClick={() => {
                        setSelectedPerfil(perfil); // Define o perfil selecionado
                        openModalPerfilPmeOpen(); // Abre o modal
                    }}
                    title="Editar Detalhes"
                >
                    <i className="fa fa-edit" aria-hidden="true"></i>
                </span>
            </Flex>
        );

    };

    useEffect(() => {
        const asyncFn = async () => {
            try {
                setIsLoading(true);
                await getPerfis();
            } catch (err) {
                console.error("Erro na inicialização:", err.message);
            } finally {
                setIsLoading(false);
            }           
        }
        asyncFn()
    }, []);

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">PME - Perfis </h5>
                        </div>
                        <div className="col-sm-12 col-md-2 col-lg-2 mt-1 ps-0">
                            <input type="button" className='default-button-red-block btn-block ' value='Adicionar Novo Perfil' onClick={openModalPerfilPmeOpen}/>
                        </div>
                    </div>
                    <div className="card">
                        <StldRow>
                            <Flex>
                                <StyledForm style={{ width: "100%" }}>
                                    {
                                        isLoading ? 
                                        <StldRow>
                                            <div className="text-center">
                                                <div className="d-flex align-items-center">
                                                    <strong style={{ color: "#EE4B21" }}>Carregando...</strong>
                                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                </div>
                                            </div>
                                        </StldRow> 
                                    :
                                        <StyledTablePmePrograma>
                                            <StyledTablePage>
                                                {
                                                    listaPerfisData?.data?.length > 0 ?
                                                    (
                                                        <div className="table-scroll font-0-9x table-bordered table-container">
                                                            <table className="table table-width table-sm">
                                                                <thead>
                                                                    <tr className="table-legend-info">
                                                                        <th key="acoes">Ações</th>
                                                                        <th key="perfil">Perfil</th>
                                                                        <th key="status">Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        listaPerfisData?.data?.map((perfil, index) => (
                                                                            <tr key={`row-perfil-${perfil.idPerfil}`}>
                                                                                <td className="text-center">{ getacoes(perfil.idPerfil) }</td>
                                                                                <td className="text-center">{ perfil.nome }</td>
                                                                                <td className="text-center">
                                                                                    {
                                                                                        perfil.status == 1 
                                                                                        ? <i className="fa fa-circle text-success" aria-hidden="true"></i>
                                                                                        : <i className="fa fa-circle text-danger" aria-hidden="true"></i>
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>                                                        
                                                    ) : listaPerfisData?.data && listaPerfisData.data?.length === 0 ? (
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Nenhum resultado encontrado!
                                                            </div>
                                                        </StldColumn>
                                                    ) : (
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Erro ao carregar os dados ou estrutura inesperada.
                                                            </div>
                                                        </StldColumn>
                                                    )
                                                }
                                            </StyledTablePage>
                                    </StyledTablePmePrograma>}
                                </StyledForm>
                            </Flex>
                        </StldRow>
                    </div>
                </StyledDefaultPage>

                <ModalPerfilPme
                    isOpen={modalPerfilPme}
                    onAfterOpen={afterModalPerfilPmeOpen}
                    onRequestClose={closeModalPerfilPme}
                    loadPage={isLoading}
                    perfisList={perfisList}
                    onUpdatePerfis={handleUpdatePerfis}
                    selectedPerfil={selectedPerfil}
                >
                </ModalPerfilPme>
            </main>
        </section>
    )
}

export const PerfilPmePage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <PmePerfil />
                </>
            )}
        </>
    );
};